import { render, staticRenderFns } from "./infosBm.vue?vue&type=template&id=7d1736da&scoped=true"
import script from "./infosBm.vue?vue&type=script&lang=ts"
export * from "./infosBm.vue?vue&type=script&lang=ts"
import style0 from "./infosBm.vue?vue&type=style&index=0&id=7d1736da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1736da",
  null
  
)

export default component.exports